import * as React from 'react';
import { useState, useEffect } from 'react';
import {
  Box,
  Card,
  Stack,
  Container,
  Typography,
  TextField,
  Avatar,
  IconButton,
  Grid,
  Snackbar,
  Alert,
  CircularProgress
} from '@mui/material';
import { PhotoCamera } from '@mui/icons-material';
import Page from '../components/Page';
import { api } from 'src/Api';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom';
import Iconify from 'src/components/Iconify';

export default function EditProfile() {
  const navigate = useNavigate();
  //   const userData = JSON.parse(localStorage.getItem('user'));
  const userData = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
  console.log('🚀 ~ EditProfile ~ userData:', userData);

  // Initialize states with userData
  const [firstName, setFirstName] = useState(userData.name || '');
  const [contact, setContact] = useState(userData.contact || '');

  const [file, setfile] = useState({ image: userData.avatar, file: '' });
  const [address, setaddress] = useState(userData?.address);
  const [websiteurl, setwebsiteUrl] = useState(userData?.website_link);
  console.log('🚀 ~ EditProfile ~ address:', address.length);

  const [loading, setloading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [alert, setalert] = useState({ visible: false, message: '' });
  const [isValidUrl, setIsValidUrl] = useState(true);
  const [helperText, setHelperText] = useState('');
  const [error, seterror] = useState({});

  const [imageloading, setimageloading] = useState(false);
  //   useEffect(() => {
  //     if (userData && userData?.location) {
  //       setaddress({
  //         address: userData?.location,
  //         lat: userData?.lat || null,
  //         lon: userData?.lon || null,
  //         country: userData?.country || null,
  //         city: userData?.city || null
  //       });
  //     }
  //   }, []);

  // useEffect(() => {
  //   setimageloading(true);
  //   if (!file) {
  //     setTimeout(() => {
  //       setimageloading(false);
  //     }, 2000);
  //   }
  // }, [file]);

  useEffect(() => {
    setimageloading(true); // Start the loader when the component renders or `file` changes
    const timer = setTimeout(() => {
      setimageloading(false); // Stop the loader after 2 seconds
    }, 1000);

    // Clean up the timer when the component unmounts or `file` changes
    return () => clearTimeout(timer);
  }, [file]);

  const [objAfter, setobjAfter] = useState({
    name: userData?.avatar,
    file: false
  });

  // Handle form save
  const handleSave = () => {
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();
    formdata.append('name', firstName);
    formdata.append('contact', contact);
    formdata.append('address', address);
    websiteurl && formdata.append('website_link', websiteurl);
    // if (address) {
    //   formdata.append('location', address?.address);
    //   formdata.append('country', address?.country);
    //   formdata.append('city', address?.city);
    //   formdata.append('lat', address?.lat);
    //   formdata.append('lon', address?.lon);
    // }

    if (file && file.file) {
      formdata.append('avatar', file?.file);
    }

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    setloading(true);
    fetch(api.updateProfile, requestOptions)
      .then((response) => {
        console.log('response', response);
        if (response.status === 200) {
          return response.json();
        } else {
          return response.json().then((error) => {
            console.log('result =====>>>>>credentail', error);
            setalert({ visible: true, message: error.error });
          });
        }
      })
      .then((result) => {
        if (result.success == true) {
          console.log('result of edit profile ', result?.data);
          localStorage.setItem('user', JSON.stringify(result?.data));
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          navigate('/dashboard/app');
        } else {
          setSnackbarOpen(true);
          setSnackbarMessage(result.message);
          setSnackbarSeverity('error');
        }
      })

      //   .then((response) =>
      //     response.text().then((result) => ({ status: response.status, body: result }))
      //   )
      //   .then(({ status, body }) => {
      //     const response = JSON.parse(body);
      //     if (status === 200 || status === 201) {
      //       console.log('response========', response);
      //       localStorage.setItem('user', JSON.stringify(response?.data));
      //       setSnackbarOpen(true);
      //       setSnackbarMessage(response.message);
      //       setSnackbarSeverity('success');
      //       navigate('/dashboard/app');
      //     } else {
      //       setSnackbarOpen(true);
      //       setSnackbarMessage(response.error);
      //       setSnackbarSeverity('error');
      //     }
      //   })
      .catch((error) => console.log('error', error))
      .finally(() => setloading(false));
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  const urlRegex =
    /^(https?:\/\/)?(www\.)?([a-zA-Z0-9_\-]+\.)+[a-zA-Z]{2,7}(\/[a-zA-Z0-9_\-#]+\/?)*$/;

  const handleChange = (e) => {
    const url = e.target.value;

    if (url.length <= 50) {
      setwebsiteUrl(url);

      // Validate URL
      if (url && !urlRegex.test(url)) {
        seterror({ url: 'Please enter a valid URL.' });
        setHelperText('Please enter a valid URL.');
      } else {
        seterror({ url: '' });

        setHelperText('');
      }
    }
  };
  const exceptThisSymbols = ['e', 'E', '+', '-', '.'];
  console.log('=======imagfe', firstName, contact, address, file);

  const validateFields = () => {
    const newErrors = {};
    if (!firstName) newErrors.firstName = 'Business Name  is required';
    if (!contact) newErrors.contact = 'Business Contact  is required';
    if (!address) newErrors.address = 'Business Address  is required';
    if (websiteurl && !urlRegex.test(websiteurl)) newErrors.websiteurl = 'Please enter a valid URL';
    seterror(newErrors);
    return Object.keys(newErrors).length == 0;
  };

  const handleSaveClick = () => {
    if (validateFields()) {
      seterror(false);
      handleSave(); // Your save function here
    }
  };

  return (
    <Page title={`Edit Profile | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="flex-start" mb={2}>
          {/* <IconButton
            style={{
              marginRight: 12,
              height: 40,
              width: 70,
              borderRadius: 5,
              backgroundColor: 'rgba(249, 0, 1,0.1)'
            }}
            onClick={() => navigate(-1)}
          >
            <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#f90001' }} />
          </IconButton> */}
          <Typography variant="h4" sx={{ color: '#f90001' }}>
            Edit Profile
          </Typography>
        </Stack>

        <Card sx={{ p: 3, pb: 2 }}>
          <Stack
            mb={2}
            direction={{ xs: 'column' }}
            style={{ display: 'flex', flexDirection: 'row' }}
            className="image_center"
          >
            <Box display="flex" justifyContent="center" mb={2} position="relative">
              {file ? (
                <Avatar
                  alt={firstName}
                  src={
                    file?.image
                      ? file.image // Provided image
                      : require('../asset/business.png') // Fallback/default image
                  }
                  // src={objAfter?.file ? file.image : file.image + `?v='${Date.now()}`}
                  // src={file.image ? file.image : require('../asset/business.png')}
                  sx={{ width: 120, height: 120 }}
                  className="image_center"
                  onLoad={() => setimageloading(false)}
                  onError={() => setimageloading(false)}
                />
              ) : (
                <CircularProgress size={120} color="red" />
              )}
              {imageloading && (
                <CircularProgress
                  size={30}
                  sx={{
                    position: 'absolute',
                    top: '40%',
                    left: '40%',
                    transform: 'translate(-50%, -50%)'
                  }}
                />
              )}
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="label"
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  right: 5,
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  '&:hover': { backgroundColor: '#f5f5f5' },
                  height: 30,
                  width: 30
                }}
              >
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  onChange={(e) => {
                    setobjAfter({
                      file: true
                    });
                    setfile({
                      image: URL.createObjectURL(e.target.files[0]),
                      file: e.target.files[0]
                    });
                  }}
                />
                <PhotoCamera sx={{ fontSize: 18 }} />
              </IconButton>
            </Box>
          </Stack>

          <Grid container spacing={2} mb={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Business Name"
                value={firstName}
                onChange={(e) => {
                  if (e.target.value.length <= 100) {
                    setFirstName(e.target.value); // Only update if length is <= 100
                    seterror({ firstName: '' });
                  }
                }}
                className="custom-textfield"
                error={!!error.firstName}
                helperText={error.firstName || ''}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Business Contact"
                value={contact}
                onChange={(e) => {
                  if (e.target.value.length <= 20) {
                    setContact(e.target.value); // Only update if length is <= 100
                    seterror({ contact: '' });
                  }
                }}
                className="custom-textfield"
                onKeyDown={(e) => exceptThisSymbols.includes(e.key) && e.preventDefault()}
                error={!!error.contact}
                helperText={error.contact || ''}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Business Website (Optional)"
                value={websiteurl}
                // disabled
                onChange={handleChange}
                // onChange={(e) => {
                //   if (e.target.value.length <= 50) {
                //     setwebsiteUrl(e.target.value); // Only update if length is <= 100
                //   }
                // }}
                className="custom-textfield"
                error={error.url}
                helperText={helperText}
                FormHelperTextProps={{
                  sx: { minHeight: '20px' }
                }}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                // type='number'
                fullWidth
                label="Business Address"
                value={address}
                onChange={(e) => {
                  if (e.target.value.length <= 100) {
                    setaddress(e.target.value); // Only update if length is <= 100
                    seterror({ address: '' });
                  } else {
                    seterror('The Address cannot exceed 100 characters');
                  }
                }}
                error={!!error.address}
                helperText={error.address || ''}
                className="custom-textfield"
              />
            </Grid>
          </Grid>
          <Grid item xs={12} md={12} display="flex" justifyContent="flex-end">
            <LoadingButton
              // onClick={() => {
              //   const urlRegex =
              //     /^(https?:\/\/)?(www\.)?([a-zA-Z0-9_\-]+\.)+[a-zA-Z]{2,7}(\/[a-zA-Z0-9_\-#]+\/?)*$/;
              //   if (!websiteurl || urlRegex.test(websiteurl)) {
              //     handleSave();
              //   } else {
              //     console.log('else edit profile');
              //   }
              // }}
              onClick={handleSaveClick}
              color="primary"
              variant="contained"
              loading={loading}
              sx={{ fontSize: 12 }}
            >
              Save Changes
            </LoadingButton>
          </Grid>
        </Card>
        <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
          <Alert onClose={handleSnackbarClose} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Container>
    </Page>
  );
}
